import { inject, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { parseMarkdownAndImagesToHtml } from '../common/conversation-transcript-thread/conversation-transcript.util';

@Pipe({
  name: 'parseMessageHtml',
  standalone: true
})
export class ParseMessageHtmlPipe implements PipeTransform {
  private readonly sanitizer = inject(DomSanitizer);

  transform(value: string | undefined | null): SafeHtml {
    const html = parseMarkdownAndImagesToHtml(value);
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
}
